import { req,reqObj } from './axiosFun';
import { downLoadReq }  from "./downLoad"
// --------------------------------2023.11.20 预警阀值-----------------------------------------
// 添加
export const add_alarm_config = (params) => { return req("post","/api/alarm_config/add_alarm_config", params) };
// 查询  
export const list_alarm_config = (params) => { return req('get',"/api/alarm_config/list_alarm_config", params) };
// 修改
export const update_alarm_config = (params) => { return req("post","/api/alarm_config/update_alarm_config", params) };
// 删除
export const del_alarm_config = (params) => { return req("post","/api/alarm_config/del_alarm_config", params) };
// 绑定计量点
export const sms_alarm_config_bind_meter = (params) => { return req("post","/api/alarm_config/sms_alarm_config_bind_meter", params) };
// 获取计量点
export const list_meter_by_config = (params) => { return req("get","/api/alarm_config/list_meter_by_config", params) };
// 获取该部门的计量点
export const getMeterInfoByDeptAndName = (params) => { return req("get","/api/alarm_config/getMeterInfoByDeptAndName", params) };
// 解绑计量点
export const sms_alarm_config_unbind_meter = (params) => { return req("post","/api/alarm_config/sms_alarm_config_unbind_meter", params) };
// ---------------------------------2023.11.21 预警记录---------------------------------------------------------------------------
// 查询
export const list_alarm_details = (params) => { return req("get","/api/alarm/list_alarm_details", params) };
// 导出
export const exportAlarmDetails = (params) => { return downLoadReq("get","/api/alarm/exportAlarmDetails", params) };
// -----------------------------------------------------------------------------------------------------
// -----------------------------------2023.11.22 群聊信息管理----------------------------------------
// 添加
export const add_send_url = (params) => { return req("post","/api/alarm_config/add_send_url", params) };
// 修改
export const update_send_url = (params) => { return req("post","/api/alarm_config/update_send_url", params) };
// 查询
export const list_send_url = (params) => { return req("get","/api/alarm_config/list_send_url", params) };
// 删除
export const del_send_url = (params) => { return req("post","/api/alarm_config/del_send_url", params) };
// 获取群聊需要绑定的信息
export const list_alarm_config_bind_url = (params) => { return req("get","/api/alarm_config/list_alarm_config_bind_url",params) };
// 群聊绑定 
export const url_bind_alarm_config = (params) => { return req("post","/api/alarm_config/url_bind_alarm_config",params) };



// WEBPACK FOOTER //
// ./src/api/alarmManager.js